let yearsList: any[] = [];

for (let index = 2021; index > 1900; index--) {
  yearsList.push({
    value: index,
    label: index
  });
}

export default yearsList;